import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initScriptLoading } from './utils/deferScriptLoading';

// Initialize script loading optimizations as early as possible
if (typeof window !== 'undefined') {
    // Initialize script loading optimizations
    initScriptLoading();
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Initialize Web Vitals reporting (sends data to Google Analytics)
reportWebVitals();
